import { Heading, Text, VStack } from '@chakra-ui/react'
import { Picture } from 'commons/components/header/Picture'
import { TextColors } from 'commons/design-system/tokens'
import { useTranslation } from 'react-i18next'
import type { UserInfo } from 'commons/types/user'

type Props = {
	userInfo: UserInfo | undefined
}

export const HeaderSection = ({ userInfo }: Props) => {
	const { t } = useTranslation()
	return (
		<VStack mb={0}>
			<Picture
				image={
					userInfo?.profilePicture ||
					`${process.env.REACT_APP_PAYMENT_FORM_URL}l/assets/img/default_user.png`
				}
			/>
			<Heading
				as='h1'
				fontFamily='Degular'
				fontWeight={700}
				fontSize='36px'
				color={TextColors.PRIMARY}
			>
				{userInfo?.name}
			</Heading>
			<Text
				fontSize='16px'
				textAlign='center'
				maxW='370px'
				lineHeight='24px'
				color={TextColors.TERTIARY}
			>
				{t('phone_form.subtitle')}
			</Text>
		</VStack>
	)
}
